export const getTMDQuestions = (state) => state.TMD.questions;
export const getProgressIndex = (state) => state.TMD.progressIndex;
export const getQuestionIndex = (state) => state.TMD.questionIndex;
